const ENDPOINT = 'https://pickup.dpd.cz/api/GetParcelShopById';

const cache = {};

export function fetchPickupPoint(id, lang = 'en') {
  const key = `${id}|${lang}`;
  if (!cache[key]) {
    cache[key] = fetch(`${ENDPOINT}?id=${encodeURIComponent(id)}&lang=${lang}`)
      .then((res) => res.json())
      .then((body) => {
        const data = body && body.data;
        if (!data) {
          throw new Error('unknown pickup point ' + id);
        }
        return {
          // the shop name: the order payload comes back with an empty label
          label: data.company || data.name || '',
          addressLine1: [data.street, data.house_number]
            .filter(Boolean)
            .join(' '),
          normStreet: data.street || '',
          normStreetNum: data.house_number || '',
          city: data.city || '',
          postalCode: data.postcode || '',
          phoneNumber: data.phone || '',
        };
      })
      .catch((err) => {
        delete cache[key];
        throw err;
      });
  }
  return cache[key];
}
